import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import SidebarConnectionVisibilityIcon from 'components/layout/buttons/SideBarConnectionVisibilityIcon';
import translations from 'services/translations/translations';

const ConnectionVisibilityIcon = (): JSX.Element => {
  const { t } = useTranslation([translations.leftBar]);
  const [tooltipIsOpen, setTooltipIsOpen] = useState(false);
  const [active, setActive] = useState(true);

  const id = 'left-bar-connection-visibility-icon';

  const toggleActive = () => {
    setActive(!active);
    window.ToggleConnectionVisibility();
  };

  return (
    <>
      <SidebarConnectionVisibilityIcon
        active={active}
        className="left-bar-icon"
        id={id}
        onClick={toggleActive}
      />
      <Tooltip
        placement="right"
        isOpen={tooltipIsOpen}
        target={id}
        toggle={() => setTooltipIsOpen(!tooltipIsOpen)}
      >
        {t(`${translations.leftBar}:tooltips:Toggle connection visibility`)}
      </Tooltip>
    </>
  );
};

export default ConnectionVisibilityIcon;
